// @ts-nocheck

import { SoundIds } from '../../../types/sounds';
import { KLCollectibleIds, KLCollectibleStatuses } from '../types/collectible';

export const KLSoundIdsByBadgeIdAndStatus = {
  // Round 1
  [KLCollectibleIds.FISHING]: {
    [KLCollectibleStatuses.WON]: SoundIds.KL_BADGE_WON_FISHING,
    [KLCollectibleStatuses.LOST]: SoundIds.KL_BADGE_LOST_FISHING,
  },
  [KLCollectibleIds.FIRECAMP]: {
    [KLCollectibleStatuses.WON]: SoundIds.KL_BADGE_WON_FIRECAMP,
    [KLCollectibleStatuses.LOST]: SoundIds.KL_BADGE_LOST_FIRECAMP,
  },
  [KLCollectibleIds.HUT]: {
    [KLCollectibleStatuses.WON]: SoundIds.KL_BADGE_WON_HUT,
    [KLCollectibleStatuses.LOST]: SoundIds.KL_BADGE_LOST_HUT,
  },
  [KLCollectibleIds.RICE]: {
    [KLCollectibleStatuses.WON]: SoundIds.KL_BADGE_WON_RICE,
    [KLCollectibleStatuses.LOST]: SoundIds.KL_BADGE_LOST_RICE,
  },
  [KLCollectibleIds.WATER]: {
    [KLCollectibleStatuses.WON]: SoundIds.KL_BADGE_WON_WATER,
    [KLCollectibleStatuses.LOST]: SoundIds.KL_BADGE_LOST_WATER,
  },
  [KLCollectibleIds.BALANCE]: {
    [KLCollectibleStatuses.WON]: SoundIds.KL_BADGE_WON_BALANCE,
    [KLCollectibleStatuses.LOST]: SoundIds.KL_BADGE_LOST_BALANCE,
  },
  [KLCollectibleIds.GRAND_BLUE]: {
    [KLCollectibleStatuses.WON]: SoundIds.KL_BADGE_WON_GRAND_BLUE,
    [KLCollectibleStatuses.LOST]: SoundIds.KL_BADGE_LOST_GRAND_BLUE,
  },
  // Round 2
  [KLCollectibleIds.DUO]: {
    [KLCollectibleStatuses.WON]: SoundIds.KL_BADGE_WON_DUO,
    [KLCollectibleStatuses.LOST]: SoundIds.KL_BADGE_LOST_DUO,
  },
  [KLCollectibleIds.SLOTH]: {
    [KLCollectibleStatuses.WON]: SoundIds.KL_BADGE_WON_SLOTH,
    [KLCollectibleStatuses.LOST]: SoundIds.KL_BADGE_LOST_SLOTH,
  },
  [KLCollectibleIds.BAMBOOS]: {
    [KLCollectibleStatuses.WON]: SoundIds.KL_BADGE_WON_BAMBOOS,
    [KLCollectibleStatuses.LOST]: SoundIds.KL_BADGE_LOST_BAMBOOS,
  },
  [KLCollectibleIds.CHOCOLATE]: {
    [KLCollectibleStatuses.WON]: SoundIds.KL_COMFORT_WON,
    [KLCollectibleStatuses.LOST]: SoundIds.KL_COMFORT_LOST,
  },
  [KLCollectibleIds.HOTEL]: {
    [KLCollectibleStatuses.WON]: SoundIds.KL_COMFORT_WON,
    [KLCollectibleStatuses.LOST]: SoundIds.KL_COMFORT_LOST,
  },
  [KLCollectibleIds.PIZZA]: {
    [KLCollectibleStatuses.WON]: SoundIds.KL_COMFORT_WON,
    [KLCollectibleStatuses.LOST]: SoundIds.KL_COMFORT_LOST,
  },
  [KLCollectibleIds.COLLAR]: {
    [KLCollectibleStatuses.WON]: SoundIds.KL_COLLAR_WON,
    [KLCollectibleStatuses.LOST]: SoundIds.KL_COLLAR_LOST,
  },
  // Round 3
  [KLCollectibleIds.MARK]: {
    0: { [KLCollectibleStatuses.WON]: SoundIds.KL_MARK_WON, [KLCollectibleStatuses.LOST]: SoundIds.KL_TAG_LOST },
    1: { [KLCollectibleStatuses.WON]: SoundIds.KL_MARK_WON, [KLCollectibleStatuses.LOST]: SoundIds.KL_TAG_LOST },
    2: { [KLCollectibleStatuses.WON]: SoundIds.KL_MARK_WON, [KLCollectibleStatuses.LOST]: SoundIds.KL_TAG_LOST },
  },
  [KLCollectibleIds.TAG]: {
    0: {
      [KLCollectibleStatuses.WON]: SoundIds.KL_TAG_WON,
      [KLCollectibleStatuses.LOST]: SoundIds.KL_TAG_LOST,
    },
    1: {
      [KLCollectibleStatuses.WON]: SoundIds.KL_TAG_WON,
      [KLCollectibleStatuses.LOST]: SoundIds.KL_TAG_LOST,
    },
    2: {
      [KLCollectibleStatuses.WON]: SoundIds.KL_TAG_WON,
      [KLCollectibleStatuses.LOST]: SoundIds.KL_TAG_LOST,
    },
  },
  [KLCollectibleIds.KNIFE]: {
    0: {
      [KLCollectibleStatuses.WON]: SoundIds.KL_KNIFE_WON,
      [KLCollectibleStatuses.LOST]: SoundIds.KL_KNIFE_LOST,
      [KLCollectibleStatuses.MISS]: SoundIds.KL_KNIFE_MISS_1,
    },
    1: {
      [KLCollectibleStatuses.WON]: SoundIds.KL_KNIFE_WON,
      [KLCollectibleStatuses.LOST]: SoundIds.KL_KNIFE_LOST,
      [KLCollectibleStatuses.MISS]: SoundIds.KL_KNIFE_MISS_2,
    },
    2: {
      [KLCollectibleStatuses.WON]: SoundIds.KL_KNIFE_WON,
      [KLCollectibleStatuses.LOST]: SoundIds.KL_KNIFE_LOST,
      [KLCollectibleStatuses.MISS]: SoundIds.KL_KNIFE_MISS_3,
    },
  },
};
